<template>
    <div>
        <el-table :data="batchSwitchList">
            <el-table-column prop="name" label="Job Name"></el-table-column>
            <el-table-column label="All Fluent">
                <template slot-scope="scope">
                    <el-switch :value="scope.row.allFluent"
                               @change="handleSwitchChange(scope.row.name, 'allFluent', $event)"
                               active-color="#13ce66"></el-switch>
                </template>
            </el-table-column>
            <el-table-column label="All Pass">
                <template slot-scope="scope">
                    <el-switch :value="scope.row.allPass"
                               @change="handleSwitchChange(scope.row.name, 'allPass', $event)"
                               active-color="#13ce66"></el-switch>
                </template>
            </el-table-column>
            <el-table-column label="One Batch">
                <template slot-scope="scope">
                    <el-switch :value="scope.row.oneBatch"
                               @change="handleSwitchChange(scope.row.name, 'oneBatch', $event)"
                               active-color="#13ce66"></el-switch>
                </template>
            </el-table-column>
            <el-table-column label="In Progress">
                <template slot-scope="scope">
                    <el-switch :value="scope.row.inProgress"
                               @change="handleSwitchChange(scope.row.name, 'inProgress', $event)"
                               active-color="#13ce66"></el-switch>
                </template>
            </el-table-column>
            <el-table-column label="Batch Size">
                <template slot-scope="scope">
                    <a @click="handleBatchSizeChange(scope.row.name)">
                        {{scope.row.batchSize}}<i class="el-icon-edit"></i>
                    </a>
                </template>
            </el-table-column>
            <el-table-column
                    label="操作">
                <template slot-scope="scope">
                    <el-button type="danger" icon="el-icon-delete" circle size="small"
                               @click="handleRemove(scope.row.name)"></el-button>
                    <el-button type="primary" icon="el-icon-refresh" circle
                               @click="refreshTableRow(scope.row.name,scope.$index)"></el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import {mapActions, mapState} from 'vuex';

    export default {
        name: 'BatchSwitchList',
        methods: {
            ...mapActions('walletSwitchSetting', [
                'batchList',
                'updateJobBatchSize',
                'updateBatchSwitchStatus',
                'deleteBatchJob',
                'getBatchSwitchByJobName',
                'buildCancelTradeList'
            ]),
            handleSwitchChange(name, switchType, status) {
                this.$confirm('确认进行此操作吗？', '提示', {type: 'warning'}).then(
                    () => {
                        this.updateBatchSwitchStatus({name, switchType, status}).then(
                            () => {
                                this.$message.success('操作成功！');
                                this.buildBatchOrCancelOrderList();
                            }
                        );
                    }
                );
            },
            handleBatchSizeChange(name) {
                this.$prompt('请输入size', '提示', {
                    inputValidator: value => {
                        return !value || !value.trim() ? '请输入size' : true;
                    }
                }).then(({value}) => {
                    this.updateJobBatchSize({name, size: Number(value)}).then(() => {
                        this.$message.success('操作成功！');
                        this.batchList();
                    });
                });
            },
            handleRemove(name) {
                this.$confirm('确认要删除该Job吗？', '提示', {type: 'warning'}).then(
                    () => {
                        this.deleteBatchJob({name}).then(() => {
                            this.$message.success('删除成功！');
                            this.buildBatchOrCancelOrderList();
                        });
                    }
                );
            },

            /** 刷新table中某行数据*/
            refreshTableRow(jobName, index) {
                this.getBatchSwitchByJobName(jobName).then(response => {
                    this.$set(this.batchSwitchList, index, response.data);
                })
            },

            buildBatchOrCancelOrderList() {
                if (this.querySwitchType === 0) {
                    this.batchList();
                }
                if (this.querySwitchType === 1) {
                    this.buildCancelTradeList();
                }
            }
        },
        computed: {
            ...mapState('walletSwitchSetting', ['batchSwitchList', 'querySwitchType'])
        },
    };
</script>

<style>
</style>
